import { render, staticRenderFns } from "./LineUp.vue?vue&type=template&id=c2088102&scoped=true&"
import script from "./LineUp.vue?vue&type=script&lang=js&"
export * from "./LineUp.vue?vue&type=script&lang=js&"
import style0 from "./LineUp.vue?vue&type=style&index=0&id=c2088102&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2088102",
  null
  
)

export default component.exports